import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useRemoveModelConceptClass } from 'src/containers/ProjectDiagram/hooks/remove/useRemoveModelConceptClass';
import { ModelConceptClassNode } from 'src/containers/ProjectDiagram/types/diagram';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

type ClassContextMenuProps = {
  node: ModelConceptClassNode;
};

export const ClassContextMenu: React.VFC<ClassContextMenuProps> = ({
  node,
}) => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();
  const handleRemoveClass = useRemoveModelConceptClass();

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.edit}
        onClick={() => {
          const entityValue = node.data.value;
          dispatch(
            uiSlice.actions.changedEntityDrawer({
              projectId,
              drawer: {
                entityValue,
                type: EntityDrawerType.CLASS,
              },
            })
          );
        }}
        text={copy.components.projectDiagram.contextMenu.seeDetails}
      />
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={() => handleRemoveClass({ key: node.data.key })}
        text={copy.components.projectDiagram.contextMenu.delete}
      />
    </Menu>
  );
};
